import { render, staticRenderFns } from "./legendModal.vue?vue&type=template&id=729dd92b"
import script from "./legendModal.vue?vue&type=script&lang=js"
export * from "./legendModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports